<template>

  <modalo
    :title="'Agendamento'"
    type="small"
    @hideModal="hideModal()"
    :modaloWatch="() => event">
    
    <form
      id="event-form"
      v-on:submit.prevent="saveEvent(event)">
      
      <div class="mb-3">
        <label>* {{ $t('Candidates') }}</label>
        <select-multiple-candidates
          v-model="candidates"
          :remove="false">
          </select-multiple-candidates>
      </div>

      <div class="form-group">
        <label>* Data e local</label>
        <div class="form-row">
          <div class="col-sm-6">
            
            <date-time
              :value="event.start_at"
              @input="setDateTime"></date-time>
            <ValidateMessage :error="validateErrors.start_at" />

          </div>
          <div class="col-sm-6">

            <select-duration 
              v-model="event.duration"></select-duration>
            <ValidateMessage :error="validateErrors.duration" />

          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="form-row">
          <div class="col-sm-3">
            
            <select
              class="form-control"
              v-model="event.type">
              <option value="phone-interview">{{ $t('Phone interview') }}</option>
              <option value="video-interview">{{ $t('Video interview') }}</option>
              <option value="on-site">{{ $t('On site') }}</option>
            </select>
            <ValidateMessage :error="validateErrors.type" />

          </div>
          <div class="col-sm-9">
            
            <div v-if="event.type === 'on-site'">
              <input-autocomplete
                :placeholder="$t('Location')"
                v-model="event.location"
                :options="[]"
                :minLength="0">
                </input-autocomplete>
              <ValidateMessage :error="validateErrors.location" />
            </div> 

          </div>
        </div>
      </div>

      <div class="form-group">
        <label class="control-label">* {{ $t('Participants') }}</label>
        <select-multiple-user v-model="event.assigned_users"></select-multiple-user>
        <ValidateMessage :error="validateErrors.assigned_users" />
        <div
          class="mt-1"
          v-if="!showGuests">
          <a
            href="javascript:void(0)"
            @click="showGuests = true">{{ $t('Add guests') }}</a>
        </div>
      </div>

      <div
        v-if="showGuests"
        class="form-group">
        <label>{{ $t('Guests') }}</label>
        <selectize-multiple-email 
          v-model="event.participants" 
          :options="[]">
          </selectize-multiple-email>
        <ValidateMessage :error="validateErrors.participants" />
      </div>

      <div class="form-group">
        <textarea-autosize
          :placeholder="$t('Note')"
          v-model="event.note"
          :min-height="30"
          :max-height="350"
          class="form-control">
          </textarea-autosize>
        <ValidateMessage :error="validateErrors.note" />
      </div>

      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="event.participants_invite"
            disabled="disabled">
          <label
            class="form-check-label">
            <span
              v-tooltip="'Não é possível notificar participantes no agendamento em massa'">
              {{ $t('Notify participants and guests') }}
              </span>
          </label>
        </div>
        <ValidateMessage :error="validateErrors.participants_invite" />
      </div>

      <div class="form-group">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="event.candidate_invite">
          <label
            class="form-check-label">
            {{ $t('Notify candidate') }}
          </label>
        </div>
        <ValidateMessage :error="validateErrors.candidate_invite" />
      </div>

      <div
        class="form-group"
        v-if="event.candidate_invite">

        <div
          v-if="candidatesWithoutEmail.length"
          class="alert alert-warning p-3 mb-3">
          <div class="mb-2">Alguns candidatos não possuem e-mails</div>
          <select-multiple-candidates
            v-model="candidatesWithoutEmail"
            :remove="false">
            </select-multiple-candidates>
        </div>

        <div class="input-group">
          <input class="form-control" :placeholder="$t('Subject')" v-model="event.candidate_invite_subject">
          <div class="input-group-append">
            <templatemail-select
              @setTemplate="setTemplate">
              </templatemail-select>
          </div>
        </div>
        <ValidateMessage :error="validateErrors.candidate_invite_subject" />

        <textarea-editable
          v-model="event.candidate_invite_body">
          </textarea-editable>
        <ValidateMessage :error="validateErrors.candidate_invite_body" />

      </div>

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="event-form"
          class="btn btn-primary">
          {{ $t('Save') }}
          </button>
        <button
          type="button"
          class="btn btn-light"
          @click.stop="hideModal()">
          {{ $t('Cancel') }}
          </button>
      </div>
    </template>

  </modalo>

</template>

<script>
import SelectMultipleCandidates from '@/components/Fields/SelectMultipleCandidates'
import SelectizeMultipleEmail from '@/components/Fields/SelectizeMultipleEmail'
import DateTime from '@/components/Fields/DateTime'
import InputAutocomplete from '@/components/Fields/InputAutocomplete'
import TemplatemailSelect from '@/components/Parts/TemplatemailSelect'
import SelectDuration from '@/components/Fields/SelectDuration'
import moment from 'moment'
import SelectMultipleUser from '@/components/Fields/SelectMultipleUser'

export default {
  name: 'MassiveEvent',
  components: {
    SelectMultipleCandidates,
    SelectizeMultipleEmail,
    DateTime,
    InputAutocomplete,
    TemplatemailSelect,
    SelectDuration,
    SelectMultipleUser
  },
  props: [
    'initEvent'
  ],
  data () {
    return {
      loading: false,
      validateErrors: false,
      event: this.defaultValues(this.initEvent),
      showGuests: false
    }
  },
  computed: {
    candidates () {
      return this.event.candidates || []
    },
    candidatesWithEmail () {
      return this
      .candidates
      .filter((candidate) => {
        return candidate.email
      })
    },
    candidatesWithoutEmail () {
      return this
      .candidates
      .filter((candidate) => {
        return !candidate.email
      })
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'type': 'on-site',
        'location': null,
        'note': null,
        'assigned_users': [
          this.$store.getters.getMe._id
        ],
        'participants': [
          // {
          //   'name': this.$store.getters.getMe.name,
          //   'email': this.$store.getters.getMe.email
          // }
        ],
        'start_at': null,
        'duration': 30,
        'participants_invite': false,
        'candidate_invite': true,
        'candidate_invite_subject': null,
        'candidate_invite_body': null
      }, values)
    },
    /*
    setTemplate
    */
    setTemplate (template) {
      this.$set(this.event, 'candidate_invite_subject', template.subject)
      this.$set(this.event, 'candidate_invite_body', template.body)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveEvent
    */
    saveEvent (event) {
      this.loading = true

      Promise.all(this.candidates.map((candidate) => {
        return this.$store.dispatch('createEvent', {
          'candidate_id': candidate._id,
          'job_id': event.job_id,
          'type': event.type,
          'location': event.location,
          'note': event.note,
          'assigned_users': event.assigned_users,
          'participants': event.participants,
          'start_at': event.start_at,
          'duration': event.duration,
          'participants_invite': event.participants_invite,
          'candidate_invite': event.candidate_invite,
          'candidate_invite_subject': event.candidate_invite_subject,
          'candidate_invite_body': event.candidate_invite_body,
          'has_group_event': this.candidates.length >= 2
        })
      }))
      .then(() => {
        this.loading = false
        this.$emit('created', {})
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    setDateTime
    */
    setDateTime (value) {
      if (value && !this.event.start_at) {
        value = moment(value).set({hour: 8}).startOf('hour').toISOString()
      }
      this.event.start_at = value
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MassiveEvent/MassiveEvent.vue